import type { MagicSearchBooking } from '@domain/magic-search';
import { formatCurrency } from '@utils/price-formatter/format-currency';
import { formatValue } from '@utils/price-formatter/format-value';

// No currency: the bare amount, never a guessed symbol.
export const formatBookingTotal = ({ total, currency }: MagicSearchBooking): string =>
  currency
    ? formatCurrency({ number: total, currency })
    : formatValue({ number: total, minimumFractionDigits: 2, maximumFractionDigits: 2 });
